import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import {
  BsCalendarWeek,
  BsCalendarPlus,
  BsPeopleFill,
  BsTrophyFill,
  BsBuildingFill,
  BsMegaphoneFill,
  BsBellFill,
  BsImageFill,
  BsPersonCircle,
  BsSunFill,
  BsMoonStarsFill,
  BsBoxArrowRight,
  BsList,
  BsChevronLeft,
  BsGrid3X3GapFill,
  BsShieldExclamation,
  BsChatSquareText,
  BsFlagFill
} from "react-icons/bs";

const menuItems = [
  {
    to: "/",
    icon: BsCalendarWeek,
    label: "Programacion",
    end: true
  },
  { to: "/conjuntos", icon: BsPeopleFill, label: "Conjuntos" },
  { to: "/concursos", icon: BsTrophyFill, label: "Concursos" },
  {
    to: "/habilitar-temporada",
    icon: BsCalendarPlus,
    label: "Habilitar temporada"
  },
  { to: "/tablados", icon: BsBuildingFill, label: "Tablados" },
  // Eventos de temporada: Prueba de Admisión, desfiles y Llamadas.
  { to: "/eventos", icon: BsFlagFill, label: "Eventos" },
  { to: "/pencas", icon: BsGrid3X3GapFill, label: "Pencas" },
  {
    to: "/notificaciones",
    icon: BsBellFill,
    label: "Notificaciones"
  },
  {
    to: "/anunciantes",
    icon: BsMegaphoneFill,
    label: "Anunciantes"
  },
  { to: "/banners", icon: BsImageFill, label: "Banners" },
  {
    to: "/moderacion",
    icon: BsShieldExclamation,
    label: "Moderación"
  },
  // M1-80 / TRA-O1-53: bandeja de "Ayudanos a mejorar".
  { to: "/feedback", icon: BsChatSquareText, label: "Feedback" }
];

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useAuth();
  const { darkMode, toggleTheme } = useTheme();

  const logoutWithRedirect = () => logout();

  return (
    <aside
      className={`
        ${collapsed ? "w-[68px]" : "w-[240px]"}
        h-screen sticky top-0 left-0 z-40
        bg-gradient-to-b from-primary-800 to-primary-900
        dark:from-sidebar-dark dark:to-[#16162a]
        flex flex-col
        transition-all duration-300 ease-in-out
        shadow-lg
      `}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-3 py-4 border-b border-white/10">
        {!collapsed && (
          <span className="text-white font-bold text-lg tracking-wide truncate">
            Carnaval BO
          </span>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 rounded-lg hover:bg-white/10 text-white/80 hover:text-white transition-colors"
          title={collapsed ? "Expandir menu" : "Colapsar menu"}
        >
          {collapsed ? <BsList size={20} /> : <BsChevronLeft size={16} />}
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-3 px-2 custom-scrollbar">
        <ul className="space-y-1">
          {menuItems.map(item => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 group
                  ${
                    isActive
                      ? "bg-white text-primary-800 shadow-md font-semibold"
                      : "text-white/75 hover:bg-white/10 hover:text-white"
                  }
                  ${collapsed ? "justify-center" : ""}
                  `
                }
              >
                <item.icon
                  size={18}
                  className="flex-shrink-0"
                />
                {!collapsed && (
                  <span className="text-sm truncate">{item.label}</span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="border-t border-white/10 p-2 space-y-1">
        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          className={`flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-white/75 hover:bg-white/10 hover:text-white transition-colors ${collapsed ? "justify-center" : ""}`}
          title={darkMode ? "Tema claro" : "Tema oscuro"}
        >
          {darkMode ? (
            <BsSunFill size={18} className="text-amber-400" />
          ) : (
            <BsMoonStarsFill size={18} />
          )}
          {!collapsed && (
            <span className="text-sm">
              {darkMode ? "Tema claro" : "Tema oscuro"}
            </span>
          )}
        </button>

        {/* User info */}
        {user && !collapsed && (
          <div className="flex items-center gap-2 px-3 py-2">
            {user.photoURL ? (
              <img
                src={user.photoURL}
                alt=""
                className="w-7 h-7 rounded-full"
              />
            ) : (
              <BsPersonCircle size={20} className="text-white/60" />
            )}
            <span className="text-xs text-white/60 truncate">{user.email}</span>
          </div>
        )}

        {/* Logout */}
        <button
          onClick={logoutWithRedirect}
          className={`flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-red-300 hover:bg-red-500/20 hover:text-red-200 transition-colors ${collapsed ? "justify-center" : ""}`}
          title="Cerrar sesion"
        >
          <BsBoxArrowRight size={18} />
          {!collapsed && <span className="text-sm">Salir</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
